import { render, staticRenderFns } from "./extensionManagement.vue?vue&type=template&id=62f0f326&scoped=true&"
import script from "./extensionManagement.vue?vue&type=script&lang=ts&"
export * from "./extensionManagement.vue?vue&type=script&lang=ts&"
import style0 from "./extensionManagement.vue?vue&type=style&index=0&id=62f0f326&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f0f326",
  null
  
)

export default component.exports